const ProfileImageSmall = ({
  src,
  className
}: {
  src?: string;
  className?: string;
}) => (
  <div
    className={
      "flex h-10 w-10 items-center justify-center overflow-hidden rounded-full " +
      className
    }
  >
    <img className="w-10" src={src} alt="" />
  </div>
);

export default ProfileImageSmall;
